import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { map, Observable } from 'rxjs'
import { environment } from '@environments/environment'
import { MemberApiResponse, ParentCompany } from '@features/insured/models/member/member.model'
import { CertificateCategory } from '@shared/models/certificate-category.model'

@Injectable({
  providedIn: 'root'
})
export class MemberService {
  private readonly http = inject(HttpClient)
  private readonly apiUrl = environment.memberApiUrl

  public getById(uuid: string): Observable<MemberApiResponse> {
    return this.http.get<MemberApiResponse>(`${this.apiUrl}/${uuid}`)
  }

  public create(data: MemberApiResponse): Observable<MemberApiResponse> {
    return this.http.post<MemberApiResponse>(this.apiUrl, data)
  }

  public update(data: MemberApiResponse): Observable<MemberApiResponse> {
    return this.http.put<MemberApiResponse>(this.apiUrl, data)
  }

  public save(data: MemberApiResponse): Observable<MemberApiResponse> {
    const uuidValue = data.uuid

    const hasUuid = uuidValue !== null &&
      uuidValue !== undefined
    return hasUuid
      ? this.update(data)
      : this.create(data)
  }

  public getParentCompanies(category: CertificateCategory, q: string): Observable<ParentCompany[]> {
    return this.http.get<ParentCompany[]>(`${this.apiUrl}/parent-companies`, {
      params: {
        category,
        q: q
      }
    })
  }

  public checkMemberExists(name: string, category: CertificateCategory): Observable<boolean> {
    return this.http.get<{ exist: boolean }>(`${this.apiUrl}/exist`, {
      params: {
        name: name,
        category: category
      }
    }).pipe(
      map(response => response.exist)
    )
  }
}
